import { isEmpty } from '@/shared/util';

import { escapeHtml, isLevelHeader } from '../text.util';
import { MAX_QUILL_LIST_INDENT } from './list.constant';
import { QuillListType } from './nested-list-clipboard.model';

export function appendQuillListUiSpan(listItem: HTMLLIElement): void {
  const uiSpan = document.createElement('span');

  // Quill list UI chrome; without it bullets/numbers render incorrectly.
  uiSpan.className = 'ql-ui';
  uiSpan.setAttribute('contenteditable', 'false');
  listItem.insertBefore(uiSpan, listItem.firstChild);
}

export function createQuillListItem({
  content,
  indent = 0,
  listType,
}: {
  content: DocumentFragment | Node;
  indent?: number;
  listType: QuillListType;
}): HTMLLIElement {
  const listItem = document.createElement('li');

  listItem.dataset.list = listType;

  if (indent > 0) {
    listItem.classList.add(`ql-indent-${Math.min(indent, MAX_QUILL_LIST_INDENT)}`);
  }

  appendQuillListUiSpan(listItem);
  listItem.appendChild(content);

  return listItem;
}

export function createBulletPoint(text: string): HTMLLIElement {
  return createQuillListItem({
    content: document.createTextNode(text),
    listType: 'bullet',
  });
}

export function buildBulletPointsHtml(lines: string[]): string {
  if (isEmpty(lines)) {
    return '';
  }

  const parts: string[] = [];
  let currentLevel = '';
  let hasLevels = false;

  lines.forEach((line) => {
    if (isEmpty(line)) {
      return;
    }

    const trimmedLine = line.trim();

    if (isLevelHeader(line)) {
      if (currentLevel) {
        parts.push('</ol>');
      }

      currentLevel = trimmedLine;
      parts.push(`<p>${escapeHtml(currentLevel)}</p><ol>`);
      hasLevels = true;

      return;
    }

    parts.push(
      `<li data-list="bullet"><span class="ql-ui" contenteditable="false"></span>${escapeHtml(trimmedLine)}</li>`,
    );
  });

  if (currentLevel) {
    parts.push('</ol>');
  }

  let result = parts.join('');

  if (!hasLevels) {
    result = `<ol>${result}</ol>`;
  }

  return result;
}
